module.exports = __webpack_public_path__ + "img/icon-usp-box.cafcaa33.svg";